import {
  useFormField,
  useFormFieldsContext,
} from '@spotify/confidence-core-react';
import { MetricsV1MetricRatioMetricSpec } from '@spotify/confidence-graphql';

import { MetricFormValues } from '../../createMetricDialog/types';
import { RatioForm } from './RatioForm';
import { replaceEntityNullWithZeroAggs } from './aggregationUtils';

export const RatioMeasurementFormFields = () => {
  const { setValues } = useFormFieldsContext<MetricFormValues>();

  const { value: entity } = useFormField<MetricFormValues, 'entity'>('entity');

  const { value: factTable } = useFormField<MetricFormValues, 'factTable'>(
    'factTable',
  );

  const { value: typeSpec } = useFormField<MetricFormValues, 'typeSpec'>(
    'typeSpec',
  );

  const handleChange = (ratioMetricSpec: MetricsV1MetricRatioMetricSpec) => {
    setValues({
      typeSpec: {
        ratioMetricSpec,
      },
      nullHandling: {
        replaceEntityNullWithZero:
          replaceEntityNullWithZeroAggs.includes(
            ratioMetricSpec.numeratorAggregation.type,
          ) ||
          replaceEntityNullWithZeroAggs.includes(
            ratioMetricSpec.denominatorAggregation.type,
          ),
      },
    });
  };

  if (!typeSpec?.ratioMetricSpec) {
    return null;
  }

  return (
    <RatioForm
      value={typeSpec.ratioMetricSpec}
      onChange={handleChange}
      entity={entity || ''}
      factTable={factTable || ''}
     data-track-source-anchor="fc742edd6f;ratio-measurement-form-fields-ratio-form"/>
  );
};
